module.exports = __webpack_public_path__ + "img/strokes.e8f70197.jpg";